import { SelectOptions } from "@/components/selectOptions/selectOptions"

export const DevicePositions = {
  // do not remove a Position unless it has been removed from ALL devices in the fleet
  // use format of Formal Name: Abbreviated Name
  "Soil Chamber": "SCh",
  "Canopy": "Cnp",
  "Ground Level": "Gnd",
  "PM": "PM",
  "GPS": "GPS",
}

export function DevicePositionOptions(): SelectOptions {
  const out = [] as SelectOptions 
  for (const key in DevicePositions) {
    out.push({
      id: key,
      value: key,
      displayName: key
    })
  }
  return out
}